/**
 * Returns the text color ('black' ou 'white') according background color brightness.
 * @param {string} bgColor - A RGB color, i.e: "rgb(240, 240, 240)"
 * @returns {string} - "black" or "white"
 */
export function getTextColorForBackground(bgColor) {
  if (!bgColor) return "black";

  const rgbMatch = bgColor.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
  if (!rgbMatch) return "black";

  const [, r, g, b] = rgbMatch.map(Number);
  const brightness = r * 0.299 + g * 0.587 + b * 0.114;

  return brightness > 160 ? "black" : "white";
}
